import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetCompOffLeaveList } from "../../Repository/Api";
import { errorMsg } from "../Toastify";
import MUIDataTable from "mui-datatables";

const DirectorCompoffLeaverequest = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [leaveList, setLeaveList] = useState([]);
  // console.log(leaveList)
  useEffect(() => {
    getLeaveList();
  }, []);

  const [active, setActive] = useState(0);
  const links = ["Pending With Me", "Pending", "Approved", "Rejected"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getLeaveList = async () => {
    const response = await GetCompOffLeaveList(token);
    if (response && response.statusCode === 200) {
      setLeaveList(response?.data?.comp_off_details);
    } else {
      errorMsg(response.message);
    }
  };

  const pendingLeaveMe = leaveList?.filter((leaveList) => leaveList.director_status === "pending")
  const pendingLeave = leaveList?.filter((leaveList) => leaveList.admin_status === "pending")
  const approvedLeave = leaveList?.filter((leaveList) => leaveList.director_status === "approved")
  const rejectedLeave = leaveList?.filter((leaveList) => leaveList.director_status === "rejected")

  let compoffLeave

  if (active === 0) {
    compoffLeave = pendingLeaveMe
  } else if (active === 1) {
    compoffLeave = pendingLeave
  } else if (active === 2) {
    compoffLeave = approvedLeave
  } else if (active === 3) {
    compoffLeave = rejectedLeave
  }


  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    viewColumns: false,
  };

  const columns = [
    {
      name: "first_name",
      label: "Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const lastName = tableMeta.rowData[1];
          return `${value} ${lastName}`;
        },
      },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "designation",
      label: "Designation",
    },
    {
      name: "date",
      label: "Worked Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY");
        },
      },
    },
    {
      name: "expiry_date",
      label: "Expired Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY");
        },
      },
    },
    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Director/DirectorSpecificComprequestview/${value}`}
            >
              View Details
            </Link>
          );
        },
        filter: false,
        download:false
      },
    },
  ];

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3 p-0">
                    <h6 className="labeltitle">Comp Off Leave Request</h6>
                  </div>
                  <div className="col-lg-6 p-0">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <MUIDataTable
                  data={compoffLeave}
                  columns={columns}
                  options={options}
                  className="mt-3"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorCompoffLeaverequest;
